import { MessageSquareText } from 'lucide-react'
import type { InboundText } from '../types.js'

function formatWhen(iso: string): string {
  return new Date(iso).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })
}

/** A worker's replies by text, newest first: their own words to the facility (SMS plan D5). Staff, the worker and the admin all read this. */
export function InboundTextList({ texts, empty }: { texts: readonly InboundText[]; empty: string }) {
  if (texts.length === 0) {
    return <p className="text-xs text-ink-mid">{empty}</p>
  }
  return (
    <ul className="divide-y divide-marine/10 rounded border border-marine/15 bg-white">
      {texts.map((text) => (
        <li key={text.inboundId} className="flex items-start gap-2.5 px-3 py-2 text-[11px]">
          <MessageSquareText aria-hidden="true" className="mt-0.5 h-3.5 w-3.5 shrink-0 text-marine" />
          <span className="min-w-0 flex-1">
            <span className="text-ink">“{text.body}”</span>
            <span className="block text-[10px] text-ink-mid/80">{formatWhen(text.at)}</span>
          </span>
        </li>
      ))}
    </ul>
  )
}
